var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarsStaking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 99.4",
    style: {
      enableBackground: "new 0 0 211.4 99.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .st0 {\r\n      fill: #FFFFFF;\r\n    }\r\n\r\n    .st1 {\r\n      fill: #E4BD5C;\r\n    }\r\n\r\n    .st2 {\r\n      fill: #EDD393;\r\n    }\r\n\r\n    .st3 {\r\n      fill: #e62833;\r\n    }\r\n\r\n    .st4 {\r\n      fill: #DBA728;\r\n    }\r\n\r\n    .st5 {\r\n      fill: #f15b62;\r\n    }\r\n\r\n    .st6 {\r\n      fill: #D78F93;\r\n    }\r\n\r\n    .st7 {\r\n      fill: #0A0A0A;\r\n    }\r\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.9,80.9c-7.7,3.8-15.7,7.6-24.3,11.3c7.2,4.1,15.5,6.5,24.4,6.5c5.7,0,11.3-1,16.4-2.8 c3.1-8,4.4-17.2,4.9-26.6c-6.4,3.8-13.1,7.4-20.1,11C50.7,80.5,50.3,80.7,49.9,80.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23,66.2c-0.2-0.1-0.3-0.2-0.5-0.3C14.8,61.1,7.5,55.9,1,50C1.1,65.2,8.1,78.7,19,87.6 c8.2-3.5,16-7,23.4-10.6C35.7,73.5,29.2,69.9,23,66.2L23,66.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M25.2,7.5C13.1,14.6,4.3,26.8,1.8,41.2c6,6,13,11.4,20.5,16.3C21.6,41.2,20.9,23.2,25.2,7.5L25.2,7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78.3,60.7c0,10.7-0.7,21.4-3.4,31.2C87,84.7,95.8,72.5,98.3,58.2c-6.2-6-13.1-11.4-20.5-16.2 C78.1,48.1,78.3,54.4,78.3,60.7L78.3,60.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M50.2,18.5c7.6-3.8,15.6-7.5,24.2-11.3C67.3,3.1,58.9,0.7,50,0.7c-5.7,0-11.2,1-16.3,2.8 c-3.1,8-4.4,17.2-4.8,26.6c6.4-3.7,13-7.4,20.1-10.9C49.4,18.9,49.8,18.7,50.2,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M76.9,33.2c0.2,0.1,0.4,0.3,0.6,0.4c7.6,4.7,14.9,9.9,21.5,15.8C99,34.3,92,20.8,81.1,11.8 c-8.3,3.5-16,7-23.3,10.6C64.2,25.8,70.7,29.4,76.9,33.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50,32.5c-8.7,0-16.5,6.7-21.8,17.2C33.5,60.2,41.3,66.9,50,66.9s16.5-6.7,21.8-17.2 C66.5,39.2,58.7,32.5,50,32.5z M50,57.2c-4.1,0-7.5-3.3-7.5-7.5s3.3-7.5,7.5-7.5s7.5,3.3,7.5,7.5S54.2,57.2,50,57.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsStaking);
export default __webpack_public_path__ + "static/media/starsStaking.559e37ef2a84720700e21b71abdae261.svg";
export { ForwardRef as ReactComponent };